<app-spinner-service></app-spinner-service>

<div class="login-container">
  <!-- Background com imagem -->
  <div class="login-background">
    <img src="/assets/grafismo/1.svg" alt="Background" class="background-image" loading="lazy">
  </div>

  <!-- Container principal -->
  <div class="login-content">
    <!-- Logo e título -->
    <div class="login-header">
             <div class="logo-container">
         <img src="../../../assets/logo/PNG/assinaturaVisual/amarelo.png" alt="AdvVenture Logo" class="login-logo" loading="lazy">
       </div>
      <h1 class="login-title">Bem-vindo de volta</h1>
      <p class="login-subtitle">Faça login para acessar sua conta</p>
    </div>

    <!-- Formulário de login -->
    <form class="login-form" [formGroup]="formLogin" (ngSubmit)="onSubmit()">
      <!-- Campo de email -->
      <div class="form-group">
        <label class="form-label" for="email">
          <i class="pi pi-envelope"></i>
          Email
        </label>
        <div class="input-container">
          <input 
            class="form-input" 
            type="email" 
            id="email"
            formControlName="email" 
            autocomplete="email"
            placeholder="Digite seu email"
            [ngClass]="{'input-error': form.email.touched && form.email.invalid}"
          >
          <div class="input-icon">
            <i class="pi pi-envelope"></i>
          </div>
        </div>
        <div class="error-message" *ngIf="form.email.touched && form.email.invalid">
          <span *ngIf="form.email.errors?.['required']">Por favor, informe o e-mail.</span>
          <span *ngIf="form.email.errors?.['email']">Por favor, informe um e-mail válido.</span>
        </div>
      </div>

      <!-- Campo de senha -->
      <div class="form-group">
        <label class="form-label" for="password">
          <i class="pi pi-lock"></i>
          Senha
        </label>
        <div class="input-container">
          <p-password 
            [style]="{'width':'100%'}" 
            [inputStyle]="{'width':'100%'}" 
            formControlName="password"
            [toggleMask]="true" 
            [feedback]="false" 
            autocomplete="current-password"
            placeholder="Digite sua senha"
            [ngClass]="{'input-error': form.password.touched && form.password.invalid}"
          >
            <ng-template pTemplate="header">
              <h6>Escolha a senha</h6>
            </ng-template>
          </p-password>
          <div class="input-icon">
            <i class="pi pi-lock"></i>
          </div>
        </div>
        <div class="error-message" *ngIf="form.password.touched && form.password.invalid">
          <span *ngIf="form.password.errors?.['required']">Por favor, informe a senha.</span>
        </div>
      </div>

      <!-- Botões de ação -->
      <div class="form-actions">
        <p-button 
          label="Entrar" 
          type="submit"
          [disabled]="!formLogin.valid || isSubmitting" 
          [loading]="isSubmitting"
          class="login-button"
        >
        </p-button>
      </div>

      <!-- Links de navegação -->
      <div class="login-links">
        <a class="link-forgot" (click)="navigateToForgotPassword()">
          <i class="pi pi-question-circle"></i>
          Esqueci minha senha
        </a>
      </div>
    </form>

    <!-- Footer -->
    <div class="login-footer">
      <p>&copy; 2024 AdvVenture. Todos os direitos reservados.</p>
    </div>
  </div>
</div>